import $ from 'jquery';

export default class UserProductCopySpecs {
  constructor($scope, UserProductService) {
    $scope.copy_specs = function() {
      if ($scope.copy.product_from == $scope.copy.product_to) {
        alert('Source and destination product cannot be the same!');
      } else {
        $scope.copying_specs = true;
        UserProductService.copy_user_product_specs($scope.copy).then(function(data) {
          if (data.success) {
            $scope.copying_specs = false;
            $.fancybox.close();
            $scope.load_user_products();
          }
        });
      }
    };

    $scope.load_products = function() {
      $scope.loading_products = true;
      $scope.products = [];
      UserProductService.get_user_products_for_copy_specs(window.user_id).then(function(data) {
        $scope.products = data.user_products;
        $scope.loading_products = false;
      });
    };

    $scope.copy = {
      product_from: null,
      product_to: null,
      reels_substance: true,
      reels_rw: true,
      reels_core: true,
      reels_diameter: true,
      reels_combinations: true,
      sheets_substance: true,
      sheets_size: true,
      sheets_combinations: true
    };

    $scope.$watch('copy', function() {
      if (!($scope.copy.reels_substance && $scope.copy.reels_rw))
        $scope.copy.reels_combinations = false;
      if (!($scope.copy.sheets_substance && $scope.copy.sheets_size))
        $scope.copy.sheets_combinations = false;
    }, true);

    $scope.init = function() {
      $scope.load_products();
    };

    $scope.init();
  }
}

UserProductCopySpecs.$inject = ['$scope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-copy-specs.ctrl.js